import axios from 'axios';
import { errorHandling } from '../errorHandling';
import { apiUrl } from '../apiUrl';

export const getLanguageSearch = (value) => (
  axios.get(`${apiUrl()}/languages?query=${value}*`)
    .then((response) => response.data)
    .catch((error) => errorHandling(error))
);

export default getLanguageSearch;
